import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

/** Prefix a raw path (e.g. "/api/admin/...") with the backend origin so
 * callers can `fetch()` a blob or open a signed URL without the axios
 * baseURL prefix. Used by admin PDF/resume viewers. */
export const backendUrl = (path) => `${BACKEND_URL}${path.startsWith("/") ? path : `/${path}`}`;

const api = axios.create({ baseURL: API, withCredentials: true });

api.interceptors.request.use((config) => {
    if (typeof window !== "undefined") {
        const adminToken = localStorage.getItem("simonara_admin_token");
        if (adminToken) config.headers.Authorization = `Bearer ${adminToken}`;
        const userToken = localStorage.getItem("simonara_user_token");
        if (userToken) config.headers["X-User-Token"] = userToken;
    }
    return config;
});

// Global 402 → Upgrade modal. The server returns
// { detail: { upgrade_required: true, feature, current_plan, required_plan, used, limit } }
// which we surface via a window event so any page can render the modal from a
// single mounted <UpgradeModalHost /> without extra plumbing per-endpoint.
api.interceptors.response.use(
    (r) => r,
    (err) => {
        try {
            const status = err?.response?.status;
            const detail = err?.response?.data?.detail;
            if (status === 402 && detail && detail.upgrade_required && typeof window !== "undefined") {
                window.dispatchEvent(new CustomEvent("simonara:upgrade-required", { detail }));
            }
        } catch (_e) {
            /* never let interceptor blow up caller */
        }
        return Promise.reject(err);
    },
);

export default api;

export const formatApiError = (err) => {
    const detail = err?.response?.data?.detail;
    if (!detail) return err?.message || "Something went wrong. Please try again.";
    // Structured entitlement 402 — the global <UpgradeModalHost/> already
    // renders a rich modal. Return an empty string so any toast() call the
    // page makes becomes a no-op, avoiding a duplicate red toast + modal
    // stacking on the same 402 (iter 70 UX finding).
    if (typeof detail === "object" && detail.upgrade_required) {
        return "";
    }
    if (typeof detail === "string") return detail;
    if (Array.isArray(detail)) return detail.map((e) => (e?.msg ? e.msg : JSON.stringify(e))).join(" ");
    if (detail?.msg) return detail.msg;
    // Structured error payloads (e.g. messaging + unlock endpoints return
    // {code, message, ...context}) — surface the human-readable message
    // instead of a raw object. Code falls through if message missing.
    if (detail?.message) return detail.message;
    if (detail?.code) return String(detail.code);
    return "Something went wrong. Please try again.";
};
